// Policy password lato CLIENT, unica per tutta l'app (registrazione e reset).
// Il server (Supabase GoTrue) impone password_min_length=6 senza requisiti di
// caratteri: il client richiede 8 per tutte le NUOVE password, restando più
// severo del server (nessuna modifica alla config server; le password
// esistenti continuano a funzionare al login).
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_MESSAGE = `La password deve avere almeno ${PASSWORD_MIN_LENGTH} caratteri.`;

export const PASSWORD_PLACEHOLDER = `almeno ${PASSWORD_MIN_LENGTH} caratteri`;

export const isPasswordValid = (pw) =>
  typeof pw === 'string' && pw.length >= PASSWORD_MIN_LENGTH;
